
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/password/reset",
      function () {
        return require("private-next-pages/auth/password/reset/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/password/reset"])
      });
    }
  